import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { defaultPageInfo, defaultPaging } from '@/common/constants/ConstCode';

const state = {
  condition: {
    category: '',
    userNo: '',
    ...defaultPaging
  },
  detail: {},
  list: [],
  pageInfo: { ...defaultPageInfo },
  register: {
    category: '',
    title: '',
    contents: '',
    firstRawFile: ''
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
